<div class="main-container">

  <div class="title">
    <span class="title-text">Check-out Desk</span>
    <p class="small-title">Guests currently checked in. Pick a premises to load the list.</p>
  </div>

  <div class="searchBar">
    <div class="each-div">
      <span class="drop-title">Premises</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="premises">
          @for(item of premisesList; track item.id){
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="each-div small">
      <span class="drop-title">Date</span>
      <input type="date" class="text-box-active" [formControl]="date" />
    </div>

    <div class="each-div small">
      <span class="drop-title">Family Code</span>
      <input type="text" class="text-box-active" [formControl]="familyCode" />
    </div>

    <div class="each-div small">
      <span class="drop-title">Booking ID</span>
      <input type="text" class="text-box-active" [formControl]="bookingId" />
    </div>

    <div class="btn">
      <button type="button" class="ac-primary-btn" (click)="search()">Search</button>
    </div>
  </div>

  @for(group of groups; track group.accommodationParentName){
  <div class="group">
    <div class="group-title">{{ group.accommodationParentName }}</div>

    <div class="table-container">
      <table class="table">
        <thead class="table-head">
          <tr>
            <th>Booking ID</th>
            <th>Family Code</th>
            <th>Name</th>
            <th>Type</th>
            <th>From</th>
            <th>To</th>
            <th>Room/Hall</th>
            <th>Status</th>
            @if(canCheckout){ <th>Action</th> }
          </tr>
        </thead>
        <tbody class="table-body">
          @for(row of group.requisitionDetails; track row.requisitionId){
          <tr>
            <td>{{ row.requisitionId }}</td>
            <td>{{ row.familyCode }}</td>
            <td>{{ row.primaryApplicantName }}</td>
            <td>{{ row.requisitionType || '-' }}</td>
            <td>{{ row.requisitionFromDate }}</td>
            <td>{{ row.requisitionToDate }}</td>
            <td>{{ row.roomOrHallName || '-' }}</td>
            <td>{{ row.requisitionStatus }}</td>
            @if(canCheckout){
            <td class="actions-cell">
              <button type="button" class="ac-danger-btn" (click)="checkOut(row)">Check Out</button>
              @if(canCancelCheckin(row)){
              <button type="button" class="ac-secondary-small-btn cancel-btn" (click)="cancelCheckin(row)">Cancel check-in</button>
              }
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }

  @if(hasSearched && groups.length === 0){
  <p class="empty">No guests to check out for this selection.</p>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
